import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { getAuthorEvaluationOptions } from '@/module/Evaluation/model/EvaluationQuery';

export const Route = createFileRoute('/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather')({
  component: RouteComponent,
  loaderDeps: ({ search: { userId } }) => ({ userId }),
  loader: async ({ context: { queryClient }, params: { evaluationId }, deps: { userId } }) => {
    if (userId == null) {
      return null;
    }

    const data = await queryClient.ensureQueryData(getAuthorEvaluationOptions(evaluationId, userId));

    if (data == null) {
      throw redirect({ to: '/evaluation/$evaluationId', params: { evaluationId }, search: true });
    }

    return data;
  },
});

function RouteComponent() {
  return <Outlet />;
}
